import { t } from '../../../../../../common/i18n.js'
import type { Language } from '../../../../../../common/types/i18n.js'
import { formatDisplayDate } from '../../../../../../common/utils/format-utils.js'
import type {
    NextJoinerLeaverItem,
    NextJoinerLeaverPayload,
} from '../../../../../../server/controllers/portal/dashboard-card-payloads.js'
import { PortalAvatar } from '../../../../../components/portal-avatar/portal-avatar.js'
import './next-joiner-leaver-card.css'

const Row = ({
    label,
    person,
    lang,
}: {
    label: string
    person: NextJoinerLeaverItem | null
    lang: Language
}) => (
    <div className="portal-next-jl__row">
        <span className="portal-card__label">{label}</span>
        {person ? (
            <div className="portal-next-jl__entry">
                <PortalAvatar
                    name={`${person.firstName} ${person.lastName}`}
                    avatarUrl={person.avatarUrl}
                    size="md"
                />
                <div className="portal-next-jl__details">
                    <span className="portal-next-jl__name">
                        {person.firstName} {person.lastName}
                    </span>
                    <span className="portal-card__subtext">
                        {formatDisplayDate(person.date, 'long', lang)}
                    </span>
                </div>
            </div>
        ) : (
            <span className="portal-card__value">
                {t.portal.dashboard.cards.next_joiner_leaver.none(lang)}
            </span>
        )}
    </div>
)

export const NextJoinerLeaverCard = ({
    data,
    lang,
}: {
    data: NextJoinerLeaverPayload
    lang: Language
}) => {
    const c = t.portal.dashboard.cards.next_joiner_leaver
    return (
        <>
            <Row label={c.nextJoinerLabel(lang)} person={data.nextJoiner} lang={lang} />
            <Row label={c.nextLeaverLabel(lang)} person={data.nextLeaver} lang={lang} />
        </>
    )
}
